<template>
    <v-layout>
        <v-icon class="mr-2"> info </v-icon>
        <div
            class="d-inline-block shape cutie text-left pa-2 ml-2 text-caption"
            style="background-color: grey; color: white"
        >
            {{ message }}
        </div>
    </v-layout>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'InfoLabel',
})
export default class InfoLabel extends Vue {
    @Prop({ default: undefined }) message: string;
}
</script>
